export default class TextControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.input.value = args.value ? args.value : ''
    this.input.type = 'text'
    this.input.autocapitalize = 'sentences'
    this.input.autocorrect = 'on'
    this.input.spellcheck = 'true'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)

    if (args.datalist) {
      this.input.setAttribute('list', args.datalist.getId())
    }

    div.appendChild(this.label)
    div.appendChild(this.input)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? this.input.value : null
  }

  setValue (value) {
    this.input.value = value
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/TextControl.js